import React from 'react'

export default function Pagevide() {
  return (
    <div>
      0
    </div>
  )
}
